import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export const S3_URL =
  "https://a1d91567-6989-4fd0-853c-f63799386a9d.selstorage.ru";

export function S3API(baseUrl: string) {
  return {
    uploadFile: async (file: File) => {
      const formData = new FormData();
      formData.append("file", file);
      const renterId = rootStore.getState().location.location.id;
      return (await crud.post(
        `${baseUrl}/s3/upload/?renter_id=${renterId}`,
        formData,
        true,
        "auto",
      )) as ApiResponse<string>;
    },
  };
}
